import { IRegion } from '../types';

export enum Region {
  Moscow = 1,
  MoscowRegion = 4593,
  SaintPetersburg = 2,
  LeningradRegion = 4588,
  /** Следующие два на бэке хранятся в другом виде, см. комменты методах апи. */
  MoscowAndRegion = -1,
  SaintPetersburgAndRegion = -2,
}

export const patchRegion = (region: IRegion) => {
  switch (region.id) {
    case Region.Moscow:
    case Region.MoscowRegion:
    case Region.MoscowAndRegion:
      return { ...region, displayName: 'Москва и МО' };

    case Region.SaintPetersburg:
    case Region.SaintPetersburgAndRegion:
    case Region.LeningradRegion:
      return { ...region, displayName: 'Санкт-Петербург и ЛО' };

    default:
      return region;
  }
};
